export const NavBarStyles = {
  container: 'w-full hidden bg-white sm:block',
  logo: 'w-52 ml-6 mt-4 mb-4'
}
